

import ajax from './ajax';


const baseURL = {
    'production': 'https://workorder.hibuddy.com.cn/webapi/',
    // 'production':'http://112.126.27.205:8080/dev/api/',
    // 'production':'http://112.126.27.205:8080/phpwebapi/',
    // 'development':'http://112.126.27.205:8080/phpwebapi/',
    // 'development':'http://192.168.1.8/hrsys/',
    'development': 'https://workorder.hibuddy.com.cn/webapi/',
    // 'development':'http://112.126.27.205:8080/dev/api/',
}

export const BASE = baseURL[process.env.NODE_ENV];

// const BASE='/api/';
const UrlConfig = {
    LOGIN: {
        url: BASE + 'login.php',
        meth: 'POST',
    },
    tenant_add: {
        url: BASE + 'tenant_add.php',
        meth: 'POST',
    },
    tenant_edit: {
        url: BASE + 'tenant_edit.php',
        meth: 'POST',
    },
    tenant_edit_microsoft: {
        url: BASE + 'tenant_edit_microsoft.php',
        meth: 'POST',
    },
    tenant_edit_status: {
        url: BASE + 'tenant_edit_status.php',
        meth: 'POST',
    },
    tenant_list: {
        url: BASE + 'tenant_list.php',
        meth: 'POST',
    },
    user_add: {
        url: BASE + 'user_add.php',
        meth: 'POST',
    },
    user_edit: {
        url: BASE + 'user_edit.php',
        meth: 'POST',
    },
    user_edit_password: {
        url: BASE + 'user_edit_password.php',
        meth: 'POST',
    },
    user_edit_status: {
        url: BASE + 'user_edit_status.php',
        meth: 'POST',
    },
    user_del: {
        url: BASE + 'user_del.php',
        meth: 'POST',
    },
    user_list: {
        url: BASE + 'user_list.php',
        meth: 'POST',
    },
    interviewer_add: {
        url: BASE + 'interviewer_add.php',
        meth: 'POST',
    },
    interviewer_edit: {
        url: BASE + 'interviewer_edit.php',
        meth: 'POST',
    },
    interviewer_list: {
        url: BASE + 'interviewer_list.php',
        meth: 'POST',
    },
    order_add: {
        url: BASE + 'order_add.php',
        meth: 'POST',
    },
    order_edit: {
        url: BASE + 'order_edit.php',
        meth: 'POST',
    },
    order_edit_status: {
        url: BASE + 'order_edit_status.php',
        meth: 'POST',
    },
    order_list: {
        url: BASE + 'order_list.php',
        meth: 'POST',
    },
    status_list: {
        url: BASE + 'status_list.php',
        meth: 'POST',
    },
    position_add: {
        url: BASE + 'position_add.php',
        meth: 'POST',
    },
    position_edit: {
        url: BASE + 'position_edit.php',
        meth: 'POST',
    },
    position_list: {
        url: BASE + 'position_list.php',
        meth: 'POST',
    },
    candidates_list: {
        url: BASE + 'candidates_list.php',
        meth: 'POST',
    },
    candidates_edit: {
        url: BASE + 'candidates_edit.php',
        meth: 'POST',
    },
    candidates_edit_status: {
        url: BASE + 'candidates_edit_status.php',
        meth: 'POST',
    },
    candidates_add: {
        url: BASE + 'candidates_add.php',
        meth: 'POST',
    },
    candidates_edit_intvtime: {
        url: BASE + 'candidates_edit_intvtime.php',
        meth: 'POST',
    },
    callrecord_list: {
        url: BASE + 'callrecord_list.php',
        meth: 'POST',
    },
    oplog_list: {
        url: BASE + 'oplog_list.php',
        meth: 'POST',
    },
    role_list: {
        url: BASE + 'role_list.php',
        meth: 'POST',
    },
    dashboard: {
        url: BASE + 'dashboard.php',
        meth: 'POST',
    },
    dashboard_order: {
        url: BASE + 'dashboard_order.php',
        meth: 'POST',
    },
    dashboard_cand: {
        url: BASE + 'dashboard_cand.php',
        meth: 'POST',
    },
    dashboard_admin: {
        url: BASE + 'dashboard_admin.php',
        meth: 'POST',
    },
    dashboard_candtrace: {
        url: BASE + 'dashboard_candtrace.php',
        meth: 'POST',
    },
    testemail: {
        url: BASE + 'testemail.php',
        meth: 'POST',
    },
    testmicrosoft: {
        url: BASE + 'testmicrosoft.php',
        meth: 'POST',
    },
    turbotq_list: {
        url: BASE + 'turbotq_list.php',
        meth: 'POST',
    },
    turbotq_view: {
        url: BASE + 'turbotq_view.php',
        meth: 'POST',
    },
}
// 用户登录
export const reqLogin = (username, password) => ajax(UrlConfig.LOGIN.url, { username, password }, UrlConfig.LOGIN.meth)
// 租户添加
export const api_tenant_add = (data) => ajax(UrlConfig.tenant_add.url, data, UrlConfig.tenant_add.meth)
// 租户修改
export const api_tenant_edit = (data) => ajax(UrlConfig.tenant_edit.url, data, UrlConfig.tenant_edit.meth)
// 租户修改微软参数
export const api_tenant_edit_microsoft = (data) => ajax(UrlConfig.tenant_edit_microsoft.url, data, UrlConfig.tenant_edit_microsoft.meth)
// 租户修改状态
export const api_tenant_edit_status = (data) => ajax(UrlConfig.tenant_edit_status.url, data, UrlConfig.tenant_edit_status.meth)
// 租户列表
export const api_tenant_list = (data) => ajax(UrlConfig.tenant_list.url, data, UrlConfig.tenant_list.meth)
// 用户添加
export const api_user_add = (data) => ajax(UrlConfig.user_add.url, data, UrlConfig.user_add.meth)
// 用户修改
export const api_user_edit = (data) => ajax(UrlConfig.user_edit.url, data, UrlConfig.user_edit.meth)
// 用户修改密码
export const api_user_edit_password = (data) => ajax(UrlConfig.user_edit_password.url, data, UrlConfig.user_edit_password.meth)
// 用户修改状态
export const api_user_edit_status = (data) => ajax(UrlConfig.user_edit_status.url, data, UrlConfig.user_edit_status.meth)
// 用户删除
export const api_user_del = (data) => ajax(UrlConfig.user_del.url, data, UrlConfig.user_del.meth)
// 用户列表
export const api_user_list = (data) => ajax(UrlConfig.user_list.url, data, UrlConfig.user_list.meth)
// 面试官添加
export const api_interviewer_add = (data) => ajax(UrlConfig.interviewer_add.url, data, UrlConfig.interviewer_add.meth)
// 面试官修改
export const api_interviewer_edit = (data) => ajax(UrlConfig.interviewer_edit.url, data, UrlConfig.interviewer_edit.meth)
// 面试官列表
export const api_interviewer_list = (data) => ajax(UrlConfig.interviewer_list.url, data, UrlConfig.interviewer_list.meth)
// 工单添加
export const api_order_add = (data) => ajax(UrlConfig.order_add.url, data, UrlConfig.order_add.meth)
// 工单修改
export const api_order_edit = (data) => ajax(UrlConfig.order_edit.url, data, UrlConfig.order_edit.meth)
// 工单修改状态
export const api_order_edit_status = (data) => ajax(UrlConfig.order_edit_status.url, data, UrlConfig.order_edit_status.meth)
// 工单列表
export const api_order_list = (data) => ajax(UrlConfig.order_list.url, data, UrlConfig.order_list.meth)
// 各种状态列表
export const api_status_list = (data) => ajax(UrlConfig.status_list.url, data, UrlConfig.status_list.meth)
// 岗位添加
export const api_position_add = (data) => ajax(UrlConfig.position_add.url, data, UrlConfig.position_add.meth)
// 岗位修改
export const api_position_edit = (data) => ajax(UrlConfig.position_edit.url, data, UrlConfig.position_edit.meth)
// 岗位列表
export const api_position_list = (data) => ajax(UrlConfig.position_list.url, data, UrlConfig.position_list.meth)
// 候选人列表
export const api_candidates_list = (data) => ajax(UrlConfig.candidates_list.url, data, UrlConfig.candidates_list.meth)
// 候选人修改
export const api_candidates_edit = (data) => ajax(UrlConfig.candidates_edit.url, data, UrlConfig.candidates_edit.meth)
// 候选人修改状态
export const api_candidates_edit_status = (data) => ajax(UrlConfig.candidates_edit_status.url, data, UrlConfig.candidates_edit_status.meth)
// 候选人添加
export const api_candidates_add = (data) => ajax(UrlConfig.candidates_add.url, data, UrlConfig.candidates_add.meth)
// 候选人改期
export const api_candidates_edit_intvtime = (data) => ajax(UrlConfig.candidates_edit_intvtime.url, data, UrlConfig.candidates_edit_intvtime.meth)
// 外呼记录列表
export const api_callrecord_list = (data) => ajax(UrlConfig.callrecord_list.url, data, UrlConfig.callrecord_list.meth)
// 操作记录列表
export const api_oplog_list = (data) => ajax(UrlConfig.oplog_list.url, data, UrlConfig.oplog_list.meth)
// 用户角色列表
export const api_role_list = (data) => ajax(UrlConfig.role_list.url, data, UrlConfig.role_list.meth)
// 数据看板统计
export const api_dashboard = (data) => ajax(UrlConfig.dashboard.url, data, UrlConfig.dashboard.meth)
// 数据看板统计_工单
export const api_dashboard_order = (data) => ajax(UrlConfig.dashboard_order.url, data, UrlConfig.dashboard_order.meth)
// 数据看板统计_候选人
export const api_dashboard_cand = (data) => ajax(UrlConfig.dashboard_cand.url, data, UrlConfig.dashboard_cand.meth)
// 数据看板统计_超级管理员
export const api_dashboard_admin = (data) => ajax(UrlConfig.dashboard_admin.url, data, UrlConfig.dashboard_admin.meth)
// 数据看板统计_候选人任务溯源
export const api_dashboard_candtrace = (data) => ajax(UrlConfig.dashboard_candtrace.url, data, UrlConfig.dashboard_candtrace.meth)
// 测试邮件
export const api_testemail = (data) => ajax(UrlConfig.testemail.url, data, UrlConfig.testemail.meth)
// 测试微软参数
export const api_testmicrosoft = (data) => ajax(UrlConfig.testmicrosoft.url, data, UrlConfig.testmicrosoft.meth)
// 学信认证列表
export const api_turbotq_list = (data) => ajax(UrlConfig.turbotq_list.url, data, UrlConfig.turbotq_list.meth)
// 学信认证报告预览
export const api_turbotq_view = (data) => ajax(UrlConfig.turbotq_view.url, data, UrlConfig.turbotq_view.meth)
